<div class="d-block d-lg-none">
  <fgb-page-header [pageTitle]="'games.page.trivia.title'" />
</div>

<div class="container">
  <div class="games-back-btn d-lg-flex d-none" routerLink="/games">
    <span class="material-icons text-black">keyboard_arrow_left</span>
    <span class="text-black">{{ 'all.games.back.btn' | translate : { fgbdefault: 'All Games' } }}</span>
  </div>

  <div class="games-banner" role="banner"></div>
</div>

<fgb-game-nav routeLink="quiz" [isRulesEnabled]="false"></fgb-game-nav>
<router-outlet></router-outlet>
